import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'About',
    href: '#about'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'Why Us',
    href: '#values'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md py-3' : 'bg-transparent py-5'}`} data-id="element-111">
      <div className="container mx-auto px-4 md:px-6 flex justify-between items-center" data-id="element-112">
        <a href="#" className="flex items-center gap-2 z-50" data-id="element-113">
          <img src="https://cdn.magicpatterns.com/uploads/gH1zzpiYp1PqJgQJpdgZgj/Logo_PNG_Resized.png" alt="Manifold Trade Logo" className={`h-24 md:h-28 w-auto transition-all duration-300 ${isScrolled ? '' : 'brightness-0 invert'}`} data-id="element-114" />
        </a>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-115">
          {navLinks.map(link => <a key={link.name} href={link.href} className={`text-sm font-medium transition-colors hover:text-[#d4a017] ${isScrolled ? 'text-[#1a4d5c]' : 'text-white'}`} data-id="element-116">
              {link.name}
            </a>)}
          <a href="#contact" className="bg-[#d4a017] hover:bg-[#b88b14] text-white px-5 py-2 rounded-md font-medium text-sm transition-colors shadow-sm" data-id="element-117">
            Get Started
          </a>
        </nav>

        {/* Mobile Menu Button */}
        <button className={`md:hidden z-50 transition-colors ${isScrolled ? 'text-[#1a4d5c]' : 'text-white'}`} onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-118">
          {isMobileMenuOpen ? <X size={24} data-id="element-119" /> : <Menu size={24} data-id="element-120" />}
        </button>

        {/* Mobile Navigation Overlay */}
        {isMobileMenuOpen && <div className="fixed inset-0 bg-white z-40 flex flex-col items-center justify-center space-y-8 md:hidden" data-id="element-121">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-2xl font-medium text-[#1a4d5c] hover:text-[#d4a017]" onClick={() => setIsMobileMenuOpen(false)} data-id="element-122">
                {link.name}
              </a>)}
            <a href="#contact" className="bg-[#d4a017] text-white px-8 py-3 rounded-md font-medium text-lg shadow-md" onClick={() => setIsMobileMenuOpen(false)} data-id="element-123">
              Get Started
            </a>
          </div>}
      </div>
    </header>;
}